import Vue from "vue";
import './plugins/vuetify'
import './plugins/vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";

// import vuetify
import Vuetify from 'vuetify'
Vue.use(Vuetify)

//import axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);


import VueSession from 'vue-session'
Vue.use(VueSession)

// import VueLodash from 'vue-lodash'
// import lodash from 'lodash'
// Vue.use(VueLodash, lodash);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
